module.exports = __webpack_public_path__ + "img/footmark_empty.2bdb610f.png";